import { render, staticRenderFns } from "./CarInspectionList.vue?vue&type=template&id=2face2f6&scoped=true&"
import script from "./CarInspectionList.vue?vue&type=script&lang=js&"
export * from "./CarInspectionList.vue?vue&type=script&lang=js&"
import style0 from "./CarInspectionList.vue?vue&type=style&index=0&id=2face2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2face2f6",
  null
  
)

export default component.exports